import { priceFormatter } from '@2wunder/klarx-tool'
import {
  CalendarOutlined,
  EnvironmentOutlined,
  EuroCircleOutlined,
  UnorderedListOutlined,
  UserOutlined
} from '@ant-design/icons'
import { Divider, Row } from 'antd'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { normalizeAddressSummary } from 'app/lib/apollo/normalizers/Rental'
import { ToolBox } from 'app/lib/hooks/toolBox'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

type Props = {
  rental: IRental
}

const RentalOverview: React.FC<Props> = ({ rental }) => {
  const { tComponent } = ToolBox.useString()
  const { tRoute } = useTranslation({ scope: 'rental.show' })
  const {
    deliveryAddress,
    start_date,
    return_date,
    duration,
    price_net_total,
    customerOrderNumber,
    quotedOrPast,
    deliveryContact,
    managerContact,
    contact
  } = rental

  const translateDuration = () => {
    return tComponent({
      componentName: 'overview',
      componentType: 'data_display',
      recordType: RecordType.rental,
      id: 'unit_days',
      values: { duration }
    })
  }

  const info = {
    dates: {
      value: `${start_date} - ${return_date} (${translateDuration()})`,
      icon: <CalendarOutlined className="text-lg" />
    },
    location: {
      value: normalizeAddressSummary(deliveryAddress),
      icon: <EnvironmentOutlined className="text-lg" />
    },
    customerOrderNumber: {
      value: customerOrderNumber,
      icon: <UnorderedListOutlined className="text-lg" />
    },
    ...(quotedOrPast && {
      price_net_total: {
        value: priceFormatter(price_net_total),
        icon: <EuroCircleOutlined className="text-lg" />
      }
    })
  }

  const contacts = {
    contact_name: { value: contact?.name, icon: <UserOutlined className="text-lg" /> },
    ...(contact?.name !== managerContact?.name &&
      managerContact?.name && {
        'managerContact.name': {
          value: managerContact.name,
          icon: <UserOutlined className="text-lg" />
        }
      }),
    'deliveryContact.name': {
      value: deliveryContact?.name,
      icon: <UserOutlined className="text-lg" />
    }
  }

  return (
    <Row>
      <KCol span={24}>
        <KInfo
          grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 3 }}
          recordType={RecordType.rental}
          member={{ ...info }}
        />
        <Divider orientation="left" className="my-0" plain>
          {tRoute({ id: 'rental_contacts' })}
        </Divider>
        <KInfo
          grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 3 }}
          recordType={RecordType.rental}
          member={{ ...contacts }}
        />
      </KCol>
    </Row>
  )
}

export default RentalOverview
